{
  "zh-CN": {
    "filteredList": {
      "actions": {
        "showFilter": "Show Filters",
        "hideFilter": "Hide Filters"
      }
    }
  }
}
